import type { FieldValues, FieldPath } from "react-hook-form";
import { FormField } from "./FormField";
import { InputField } from "../ui/InputField";
import type { InputProps } from "../ui/Input";

interface FormInputFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<InputProps, "name" | "value" | "onChange" | "onBlur" | "ref"> {
  name: TName;
  label?: string;
}

export function FormInputField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, label, ...inputProps }: FormInputFieldProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ errorMessage, ...fieldProps }) => (
        <InputField
          {...inputProps}
          {...fieldProps}
          label={label}
          errorMessage={errorMessage}
        />
      )}
    />
  );
}
